import React from "react";
import {handleAnswersInput} from  "../../edit_quiz_helper/EditQuizHelper.jsx"
export function Answer({badgeclass , value, Questionedit, focusblink, blurblink,qai,ans_key, data, ...restprops}){
    if(qai >= 0 && ans_key >=0)
    {
        return(
            <span {...restprops} className={badgeclass} onFocus={focusblink} onBlur={blurblink} spellcheck="false" data-gramm="false" contentEditable={Questionedit} onInput={handleAnswersInput({ques_key: qai, ans_key: ans_key,quizdata: data})}>{value}</span>
        );
    }
    else{
        return(
            <span {...restprops} className={badgeclass} onFocus={focusblink} onBlur={blurblink} spellcheck="false" data-gramm="false" contentEditable={Questionedit}>{value}</span>
        );
    }
    
}